import { render, staticRenderFns } from "./GeneralFooter.vue?vue&type=template&id=1d7d9a94"
import script from "./GeneralFooter.vue?vue&type=script&lang=ts"
export * from "./GeneralFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports